export default {
    APP_NAME: 'Acoralia',
    END_POINT: 'https://acoralia.herokuapp.com/api/'
}



// WEBPACK FOOTER //
// ./config/production.js